import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import Lodinging from "../components_root/loading";
import Error_page from "./error";
import Page_view from "../page_root/page_view";
import Home_page from "../page_root/index";

export default function Idpage() {

  const { id } = useParams(); // slug
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [page_viewdata, setPage_viewdata] = useState(null);

  useEffect(() => {

    const fetchData = async () => {

      try {

        setLoading(true);
        setError(false);
        setPage_viewdata(null);

        const companyuid = Cookies.get("website_company_uid");

        const servicetablename = "companies";
        const tablename = "pages";

        const companySnap = await getDocs(
          query(
            collection(db, servicetablename, companyuid, tablename),
            where("slug", "==", id)
          )
        );

        if (!companySnap.empty) {

          const data = companySnap.docs[0].data();

          setPage_viewdata({
            ...data,
            uid: companySnap.docs[0].id
          });

          setLoading(false);
          return;
        }

        setError(true);
        setLoading(false);

      } catch (err) {
        console.error("Error:", err);
        setError(true);
        setLoading(false);
      }

    };

    if (id) fetchData();

  }, [id]);

  // loading
  if (loading) {
    return (
      <div className="container_roots">
        <Lodinging />
      </div>
    );
  }

  // page found
  if (page_viewdata) {
    return <Page_view data={page_viewdata} />;
  }

  // error
  if (error) {
    return <Error_page />;
  }

  return <Home_page />;
}